module.exports = __webpack_public_path__ + "static/media/Bar_CS.e940cb19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/Bar_CS.svg
// module id = 277
// module chunks = 0